import { useAuthStore, useAuthTokenStore } from '../store/authStore';

const isCurrentAccountRequest = (
  requestedAui: string,
  requestedUser: ReturnType<typeof useAuthStore.getState>['user'],
): boolean =>
  !!useAuthTokenStore.getState().authToken
  && useAuthStore.getState().user === requestedUser
  && requestedUser?.aui === requestedAui;

export const runCurrentAccountRequest = async <Response, Result>(
  requestedAui: string,
  request: () => Promise<Response>,
  onSuccess: (response: Response) => Result,
): Promise<Result | undefined> => {
  const requestedUser = useAuthStore.getState().user;
  if (!isCurrentAccountRequest(requestedAui, requestedUser)) return undefined;

  try {
    const response = await request();
    if (!isCurrentAccountRequest(requestedAui, requestedUser)) return undefined;
    return onSuccess(response);
  } catch (error) {
    if (!isCurrentAccountRequest(requestedAui, requestedUser)) return undefined;
    throw error;
  }
};
